import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import MemberFunctionInfo from "@/components/Member/FunctionInfo";

const TABLE_NAME = "memberFunc";

const App = () => {

    const [[{ title, show, hide, width = 1150, isLogin = false, type = 0 }]] = useWatchState(["modal." + TABLE_NAME])

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <MemberFunctionInfo type={type} isLogin={isLogin} onClose={hide} />
        </Modal>
    );
}

export default App;